export default __webpack_public_path__ + "static/media/MV.356e730e.svg";